import React from 'react'
import { StyledTableContainer, StyledRowContainer } from 'assets/styles/global'
import Icon from 'components/UI/Icons'
import { useHistory } from 'react-router-dom'

const RunningApplications = () => {
    const history = useHistory()
    return (
        <StyledTableContainer>
            <StyledRowContainer status='2' onClick={() => history.push('/applications')}>
                <div className='hero'>
                    <Icon name='server' className='w-8' />
                    <div className='ml-3'>
                        <p className='title'>DB host</p>
                        <p className='detail'>Localhost:1904</p>
                    </div>
                </div>
                <div>
                    <p className='title'>DB name</p>
                    <p className='detail'>Test environ</p>
                </div>
                <div>
                    <p className='title'>Health status</p>
                    <p className='detail status'>Active</p>
                </div>
                <div className='last'>
                    <p className='title'>Date created</p>
                    <p className='detail'>12 - 06 - 2020</p>
                </div>
                <div>
                    <button className='btn'>View</button>
                </div>
            </StyledRowContainer>
        </StyledTableContainer>
    )
}

export default RunningApplications
